export default __webpack_public_path__ + "static/media/023-cocos-island.41f74b1c.svg";